import { dateHelper } from '@/utils/dateHelper'

/**
 * Format timestamp to relative time display
 * @param {number} timestamp - Unix timestamp
 * @returns {string} - Formatted time display
 */
export const formatTimeDisplay = (timestamp) => {
  if (!timestamp) return '-'

  const start = dateHelper.parse(timestamp * 1000)
  const now = dateHelper.now()
  const diffInHours = dateHelper.diff(now, start, 'hour')

  if (diffInHours < 1) {
    const diffInMinutes = dateHelper.diff(now, start, 'minute')
    return `${diffInMinutes} dakika önce`
  }
  if (diffInHours < 24) {
    return `${diffInHours} saat önce`
  }

  const diffInDays = Math.floor(diffInHours / 24)
  return `${diffInDays} gün önce`
}
